<template>
  <div class="dm-container">
    <transition name="el-fade-in">
      <div class="mask" v-show="loading">
        <i class="el-icon-loading" />
      </div>
    </transition>
    <div class="map-container" id="map-container"></div>
    <!-- 弹窗 -->
    <transition name="el-zoom-in-center">
      <div class="map-pop" v-show="mapPopShow">
        <div class="flex_bc">
          <span>{{ M_data.title }}</span>
          <i class="el-icon-circle-close icon" @click="closePop"></i>
        </div>
        <monitor-page
          class="monitor-box"
          ref="monitor"
          :M_list="lists"
          :M_data="M_data"
          :topTag="false"
          v-if="showMonitor"
        />
      </div>
    </transition>
  </div>
</template>
<script>
  import AMap from 'AMap'
  import { mapGetters } from 'vuex'
  import mapObj from '@/utils/drawnMap'
  // 监控
  import monitorPage from './monitormMap.vue'
  export default {
    data() {
      return {
        map: '',
        loading: true,
        markerList: [],
        showMonitor: false,
        lists: [
          {
            name: '117ea0a854254faf8737e40ea0c7fa0d',
            title: '安居尔花苑大门外',
            site: 1,
            id: 1,
          },
          {
            name: 'a69ca5aaf42d4ad29d6608f72bb471c7',
            title: '安居尔花苑生活区',
            site: 1,
            id: 2,
          },
          // {
          //   name: '0188f20058994971ad050fd3f6d7f1da',
          //   title: '伊宁市贝语新城售楼中心VIP室',
          //   site: 1,
          //   id: 1,
          // },
          // {
          //   name: '288a464800bd4f0baf17d57cd73ec1f7',
          //   title: '伊宁市贝语新城售楼中心东南角',
          //   site: 1,
          //   id: 2,
          // },
          // {
          //   name: '7846e240cfad44edb530ef34f7aa20c4',
          //   title: '伊宁市贝语新城售楼中心西北角',
          //   site: 1,
          //   id: 3,
          // },
          // {
          //   name: 'ae61fa794dc941d5ab998fd3361e8805',
          //   title: '伊宁市恒大绿洲四期14#15#大门外',
          //   site: 1,
          //   id: 4,
          // },
        ],
        M_data: {},
        mapPopShow: false,
      }
    },
    components: { monitorPage },
    computed: {
      ...mapGetters({
        monitorList: 'map/monitorList',
        clickslide: 'map/clickslide',
      }),
    },
    watch: {
      clickslide(data) {
        this.setMarkers(data)
      },
      $route() {
        this.mapPopShow = false
        this.showMonitor = false
      },
    },
    beforeDestroy() {
      this.mapPopShow = false
      this.showMonitor = false
    },
    mounted() {
      this.defaultlists = JSON.parse(JSON.stringify(this.lists))
      this.init(() => {
        let timer = setTimeout(() => {
          clearTimeout(timer)
          this.loading = false
        }, 500)
      })
    },
    methods: {
      init(callback) {
        // 手绘图
        var imageLayer = new AMap.ImageLayer({
          url: require('../../assets/map_images/shouhui1.png'),
          bounds: new AMap.Bounds(
            [89.166896, 43.698299],
            [88.630171, 43.190014]
          ),
          zooms: [3, 20],
        })

        let map = (this.map = new AMap.Map('map-container', {
          center: [88.915617, 43.406466],
          zooms: [11, 14],
          mapStyle: 'amap://styles/darkblue',
        }))
        map.setZoom(12.5)
        // 地图只要背景
        map.setFeatures('bg')
        // 添加手绘图
        map.add(imageLayer)
        // 地图加载成功回调
        map.on('complete', () => {
          callback()
        })
        // 限制可拖动范围
        var bounds = map.getBounds(
          [88.871843, 43.641229],
          [88.667795, 43.25077]
        )
        map.setLimitBounds(bounds)
        // 地图点击事件
        map.on('click', function (e) {
          this.mapPopShow = false
          this.showMonitor = false
          console.log(e.lnglat.getLng() + ',' + e.lnglat.getLat())
        })
        this.setMarkers(this.clickslide)
      },
      // 标点
      addmarker(item) {
        let that = this
        let marker = new AMap.Marker({
          position: item.position,
          offset: new AMap.Pixel(item.off[0], item.off[1]),
          title: item.name,
          extData: item,
          content: '<div class="markerClass ' + item.className + '"></div>', // 自定义覆盖物
        })
        marker.on('click', that.clickMarker)
        // 当点击的是 监控  添加 文本点
        if (item.name == 'monitor') {
          marker.setLabel({
            direction: 'top',
            offset: new AMap.Pixel(10, 0), //设置文本标注偏移量
            content: "<div class='infoMaker'>" + item.title + '</div>', //设置文本标注内容
          })
        }
        return marker
      },
      // 根据轮播导航 设置地图标点
      setMarkers(obj) {
        // 清除已经有的 marker
        if (this.markerList.length) {
          this.map.remove(this.markerList)
        }
        let list = []
        // 如果是 点击的全部  标出所有的点  mapObj： 只是存的分类图片 和位置，比如 视频 和wifi
        if (obj.name == 'all') {
          Object.keys(mapObj).forEach((key) => {
            list = list.concat(mapObj[key])
          })
        } else {
          list = mapObj[obj.name]
        }
        if (list) {
          let that = this
          list.map((item, index) => {
            if (item.name == 'monitor') {
              let obj = that.monitorList[index]
              item.title = obj && obj.title
              item.code = obj && obj.name
            }
            let m = this.addmarker(item)
            this.markerList.push(m)
            this.map.add(m)
          })
        }
      },
      // marker点击事件
      clickMarker(ev) {
        let data = ev.target._originOpts
        if (data.title == 'monitor') {
          this.mapPopShow = true
          this.$nextTick(() => {
            // 切换弹窗的时候  数据会为空 所以 深度拷贝一次
            // this.lists = JSON.parse(JSON.stringify(this.defaultlists))
            this.M_data = {
              code: data.extData.code,
              title: data.extData.title,
            }
            this.showMonitor = true
          })
        }
      },
      // 关闭弹窗
      closePop() {
        this.mapPopShow = false
        this.showMonitor = false
      },
    },
  }
</script>
<style>
  /* 地图 logo 隐藏 */
  .amap-logo {
    display: none !important;
  }
  .amap-copyright {
    opacity: 0;
  }
  .amap-marker-label {
    background: rgba(16, 177, 119, 0.5);
    border-color: #079763;
    border-radius: 10px;
  }
  /* 文本点 */
  .infoMaker {
    color: #fff;
  }
  /* 图片点 */
  .markerClass {
    width: 50px;
    height: 50px;
    position: relative;
    outline: none;
    transform-origin: 0 0;
    display: block;
    animation: spin 2s linear infinite;
  }
  .monitorclass {
    background: url('../../assets/main/map/icon_camera.png') no-repeat;
    background-size: 100% 100%;
  }
  .wificlass {
    background: url('../../assets/main/map/icon_wifi.png') no-repeat;
    background-size: 100% 100%;
  }
  .parkingLotclass {
    background: url('../../assets/main/map/icon_p.png') no-repeat;
    background-size: 100% 100%;
  }
  @keyframes spin {
    0% {
      opacity: 0.85;
      transform: translateY(0);
    }
    50% {
      opacity: 1;
      transform: translateY(-5px);
    }
    100% {
      opacity: 0.85;
      transform: translateY(0);
    }
  }
  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
      filter: alpha(opacity=0);
    }
    50% {
      opacity: 1;
      filter: none;
    }
    100% {
      transform: scale(1.2, 1.2);
      opacity: 0;
      filter: alpha(opacity=0);
    }
  }
</style>

<style lang="scss" scoped>
  .map-container,
  .dm-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .dm-container {
    position: relative;
    .mask {
      position: absolute;
      z-index: 9;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba($color: #fff, $alpha: 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      color: white;
      font-size: 28px;
    }
  }
  .map-pop {
    width: 40%;
    height: 60%;
    background: rgba($color: #1b2225, $alpha: 0.8);
    position: absolute;
    top: 20%;
    left: 30%;
    border-radius: 16px;
    border: 1px solid #55ecb8;
    color: #fff;
    z-index: 999;
    padding: 20px;
    i {
      cursor: pointer;
    }
    .flex_bc {
      width: 92%;
      position: absolute;
      left: 5%;
      top: 8px;
      font-size: 24px;
      color: #55ecb8;

      span {
        flex: 1;
        font-size: 16px;
        text-align: left;
      }
    }
  }
  .monitor-box {
    height: 59vh;
    width: 100%;
  }
</style>
